
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BoardCard } from '@fry/boards/lib';
import { ListService } from '@fry/lib/list';
import { UnboxedModule } from '@fry/ui';
import { Observable, of } from 'rxjs';
import { MaterialModule } from '@fry/components/material';
import { QuillViewComponent } from 'ngx-quill';

@Component({
    imports: [
    UnboxedModule,
    MaterialModule,
    QuillViewComponent
],
    selector: 'eas-text-card',
    templateUrl: './text-card.view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        ListService,
    ]
})
export class TextCardViewComponent {
  static key = 'TextCardComponent';

  card = input.required<BoardCard>();

  ngOnInit(): void {
  }

  isVisible(): Observable<boolean> {
    return of(true);
  }

}
